import React from 'react';
import { Message } from 'semantic-ui-react';
import IngestionLogTable from '~/features/admin/IngestionLog/IngestionLogTable';
import { useUserContext } from '~/hooks';

export default function AdminIngestionLog() {
  const { loggedInUser } = useUserContext();

  if (!loggedInUser?.isAdmin) {
    return <Message negative>Only admin users can view the ingestion log.</Message>;
  }

  return (
    <div style={{ padding: '2rem' }}>
      <h1>AI data ingestion log</h1>
      <IngestionLogTable />
    </div>
  );
}
